<template>
    <div class="article-box">
        <div class="">
            <div class="white-bg">
                <div class="news-title">
                    <span class="weizhi">
                        您现在的位置是：
                        <a href="../../index.html">首页</a>
                        &nbsp;>&nbsp;
                        <a href="../index.html">{{ detail.head }}</a>
                    </span>
                    <h2>{{ detail.head }}</h2>
                </div>
                <div class="news-text-box">
                    <h1 class="news-title-h1">{{ cdetail.title }}</h1>
                    <div class="pic-view-other">
                        <span class="po-date">{{ detail.time }}</span>
                    </div>
                    <div class="small-text">
                        <i></i>
                        {{ detail.desc }}
                    </div>
                    <div style="margin-bottom: 10px">
                        <!-- 价格: {{ detail.price }}元 &nbsp;&nbsp;&nbsp;&nbsp; -->
                        联系人:{{ detail.linkUser }} &nbsp;&nbsp;&nbsp;&nbsp; 联系电话:{{ isLogin ? detail.linkPhone : ' 请登录后查看联系方式' }}
                    </div>
                    <div class="news-text" v-html="detail.content"></div>
                    <div class="clear"></div>
                </div>
            </div>
            <div class="clear blank"></div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import info from '../../../public/test/info1.json';
export default {
    name: 'Detail',
    data() {
        return {
            info,
            detail: '',
            cdetail: ''
        };
    },
    computed: {
        ...mapState(['isLogin'])
    },
    created() {
        let i = Number(this.$route.query.id);
        let c = Number(this.$route.query.cid);
        this.detail = this.info[i];
        this.cdetail = this.detail.list[c];
    }
};
</script>

<style scoped></style>
